module.exports = __webpack_public_path__ + "static/img/fdfszyy.f9904d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/fdfszyy.png
// module id = KfHM
// module chunks = 0